// extracted by mini-css-extract-plugin
export var danger = "_41-6";
export var lightPink = "_41-a";
export var medium = "_41-j";
export var nearSquare = "_41-m";
export var neutralBlue = "_41-8";
export var neutralYellow = "_41-7";
export var noCapitalize = "_41-1";
export var normal = "_41-2";
export var pill = "_41-0";
export var primary = "_41-3";
export var primaryLight = "_41-4";
export var shadow = "_41-n";
export var small = "_41-k";
export var solidBlack = "_41-i";
export var solidGreen = "_41-d";
export var solidLightBlue = "_41-f";
export var solidNavy = "_41-e";
export var solidOrange = "_41-h";
export var solidPink = "_41-g";
export var solidRed = "_41-b";
export var solidWhite = "_41-9";
export var solidYellow = "_41-c";
export var success = "_41-5";
export var xsmall = "_41-l";